module.exports = "<div class=\"fixed\">\n  <mat-progress-bar mode=\"indeterminate\" *ngIf=\"show\"></mat-progress-bar>\n</div>\n"